<template>
  <section class="products">
    <h2 class="section-title">产品中心</h2>
    <p class="subtitle">AI 赋能的智能台球生态系统</p>

    <div class="product-main">
      <div class="product-image">
        <img src="../assets/Products/1.jpg" alt="AI 灵犀系统" />
      </div>
      <div class="product-content">
        <h3>AI 灵犀 · 全感台球互动系统</h3>
        <ul class="feature-list">
          <li>
            <span class="feature-icon">✓</span>
            <div class="feature-text">
              <strong>AI 路线引擎</strong>
              <p>自研"台球行为决策大模型"，通过数万场顶级业余数据训练</p>
            </div>
          </li>
          <li>
            <span class="feature-icon">✓</span>
            <div class="feature-text">
              <strong>智能氛围系统</strong>
              <p>光网互动引擎，多维度触发闪耀光环</p>
            </div>
          </li>
          <li>
            <span class="feature-icon">✓</span>
            <div class="feature-text">
              <strong>零门槛社交</strong>
              <p>即插即用，赛事所有传球消息，无需改造场地</p>
            </div>
          </li>
        </ul>
        <button class="learn-more">了解更多</button>
      </div>
    </div>

    <div class="product-slider" @mouseenter="handleMouseEnter" @mouseleave="handleMouseLeave">
      <div class="product-grid">
        <div class="product-item">
          <img src="../assets/Products/2.jpg" alt="耳边助教" />
          <h3>耳边助教</h3>
          <ul class="product-features">
            <li>· 破空VR视野，随时随手指打</li>
            <li>· 从小白到高手的"唯品路径"</li>
            <li>· 轻量化语音与视觉本地版</li>
          </ul>
        </div>
        <div class="product-item">
          <img src="../assets/Products/3.jpg" alt="云竞台球·全域竞技平台" />
          <h3>云竞台球·全域竞技平台</h3>
          <ul class="product-features">
            <li>· 多渠道对战</li>
            <li>· 全网播台</li>
            <li>· 数据化语音与完本末诵</li>
          </ul>
        </div>
        <div class="product-item">
          <img src="../assets/Products/4.jpg" alt="AI 智能球桌与配套设备" />
          <h3>AI 智能球桌与配套设备</h3>
          <ul class="product-features">
            <li>· 感应探测器器</li>
            <li>· 专业训练系统</li>
            <li>· 智能台球</li>
          </ul>
        </div>
        <div class="product-item">
          <img src="../assets/Products/5.jpg" alt="台球娱乐扑克" />
          <h3>台球娱乐扑克</h3>
          <ul class="product-features">
            <li>· 专业台球配套游戏道具</li>
            <li>· 追分模式独家设计</li>
            <li>· 画风精美独特</li>
          </ul>
        </div>
        <div class="product-item">
          <img src="../assets/Products/6.jpg" alt="AI 教练" />
          <h3>AI 教练</h3>
          <ul class="product-features">
            <li>· 国家级教练水平</li>
            <li>· 24小时在线</li>
            <li>· 专属Ai教练个性化定制</li>
          </ul>
        </div>
      </div>

    </div>
  </section>
</template>

<script>
export default {
  name: 'Products',
  data() {
    return {
      currentIndex: 0,
      autoScrollInterval: null,
      isAutoScrolling: true
    }
  },
  mounted() {
    this.startAutoScroll();
  },
  beforeDestroy() {
    this.stopAutoScroll();
  },
  methods: {
    startAutoScroll() {
      this.autoScrollInterval = setInterval(() => {
        if (this.isAutoScrolling) {
          this.nextSlide();
        }
      }, 5000);
    },
    stopAutoScroll() {
      clearInterval(this.autoScrollInterval);
    },
    getItemsPerView() {
      if (window.innerWidth <= 768) {
        return 1;
      } else if (window.innerWidth <= 1024) {
        return 2;
      }
      return 3;
    },
    nextSlide() {
      const grid = this.$el.querySelector('.product-grid');
      const items = grid.children;
      const itemsPerView = this.getItemsPerView();
      const maxIndex = Math.max(items.length - itemsPerView, 0);
      this.currentIndex = this.currentIndex >= maxIndex ? 0 : this.currentIndex + 1;
      this.scrollToIndex(this.currentIndex);
    },
    prevSlide() {
      const grid = this.$el.querySelector('.product-grid');
      const items = grid.children;
      const itemsPerView = this.getItemsPerView();
      const maxIndex = Math.max(items.length - itemsPerView, 0);
      this.currentIndex = this.currentIndex === 0 ? maxIndex : this.currentIndex - 1;
      this.scrollToIndex(this.currentIndex);
    },
    scrollToIndex(index) {
      const grid = this.$el.querySelector('.product-grid');
      // 计算单个卡片宽度（含间距）
      const gap = parseFloat(getComputedStyle(grid).gap) || 0;
      const itemWidth = grid.children[0].offsetWidth + gap;
      if (window.innerWidth <= 768) {
        // 移动端使用原生滚动而不是 transform
        grid.scrollTo({
          left: index * itemWidth,
          behavior: 'smooth'
        });
        // 清除之前可能设置的 transform，避免产生空白
        grid.style.transform = 'none';
      } else {
        grid.style.transform = `translateX(-${index * itemWidth}px)`;
      }
    },
    handleMouseEnter() {
      this.isAutoScrolling = false;
    },
    handleMouseLeave() {
      this.isAutoScrolling = true;
    }
  }
}
</script>

<style scoped>
.products {
  padding: 4rem 5%;
  background-color: rgba(0, 0, 0, 0.02);
  backdrop-filter: blur(10px);
  position: relative;
}

.section-title {
  text-align: center;
  font-size: 2.5rem;
  margin-bottom: 1rem;
  color: #333;
}

.subtitle {
  text-align: center;
  color: #666;
  font-size: 1.1rem;
  margin-bottom: 4rem;
}

.product-main {
  display: flex;
  justify-content: center;
  gap: 6rem;
  margin-bottom: 6rem;
  align-items: center;
  max-width: 1400px;
  margin-left: auto;
  margin-right: auto;
  padding: 0 2rem;
}

.product-content {
  flex: 1;
  max-width: 600px;
}

.product-content h3 {
  font-size: 2.4rem;
  margin-bottom: 2.5rem;
  color: #333;
  line-height: 1.3;
}

.feature-list {
  list-style: none;
  padding: 0;
  margin-bottom: 2.5rem;
}

.feature-list li {
  display: flex;
  align-items: flex-start;
  margin-bottom: 2rem;
}

.feature-icon {
  color: #ff0000;
  margin-right: 1.2rem;
  font-weight: bold;
  font-size: 1.2rem;
}

.feature-text strong {
  display: block;
  color: #333;
  margin-bottom: 0.7rem;
  font-size: 1.3rem;
}

.feature-text p {
  color: #666;
  margin: 0;
  line-height: 1.6;
  font-size: 1.1rem;
}

.product-image {
  flex: 1;
  max-width: 55%;
}

.product-image img {
  width: 100%;
  border-radius: 16px;
  box-shadow: 0 15px 40px rgba(0, 0, 0, 0.15);
  transition: transform 0.3s ease;
}

.product-image img:hover {
  transform: scale(1.02);
}

.product-info h3 {
  font-size: 1.8rem;
  margin-bottom: 1.5rem;
  color: #333;
}

.product-info ul {
  list-style: none;
  padding: 0;
}

.product-info li {
  margin-bottom: 1rem;
  padding-left: 1.5rem;
  position: relative;
  color: #666;
}

.product-info li::before {
  content: "•";
  color: #ff0000;
  position: absolute;
  left: 0;
}

.learn-more {
  background-color: #ff0000;
  color: white;
  border: none;
  padding: 0.8rem 2rem;
  border-radius: 4px;
  font-size: 1rem;
  cursor: pointer;
  margin-top: 1.5rem;
  transition: background-color 0.3s;
}

.learn-more:hover {
  background-color: #e60000;
}

.product-slider {
  position: relative;
  overflow: hidden;
  padding: 2rem 0;
}

.product-grid {
  display: flex;
  gap: 2.5rem;
  transition: transform 0.8s ease;
  padding: 1rem 0.5rem;
}

/*控制卡片大小*/
.product-item {
  flex: 0 0 calc(29.2%);
  background: #fff;
  border-radius: 16px;
  padding: 2.4rem;
  box-shadow: 0 4px 30px rgba(0, 0, 0, 0.08);
  transition: transform 0.3s ease, box-shadow 0.3s ease;
}

.product-item:hover {
  transform: translateY(-8px);
  box-shadow: 0 8px 35px rgba(0, 0, 0, 0.12);
}

.product-item img {
  width: 100%;
  height: auto;
  border-radius: 12px;
  margin-bottom: 2rem;
  display: block;
}

.product-item h3 {
  font-size: 1.5rem;
  margin-bottom: 1.5rem;
  color: #333;
}

.product-features {
  list-style: none;
  padding: 0;
  color: #666;
}

.product-features li {
  margin-bottom: 1rem;
  font-size: 1.1rem;
  line-height: 1.6;
  padding-left: 1.2rem;
  position: relative;
}

.product-features li::before {
  content: "·";
  position: absolute;
  left: 0;
  color: #333;
  font-weight: bold;
  font-size: 1.5rem;
  line-height: 1;
}

@media (max-width: 1024px) {
  .products {
    padding: 3rem 4%;
  }

  .section-title {
    font-size: 2.2rem;
  }

  .product-main {
    gap: 4rem;
    padding: 0 1.5rem;
  }

  .product-content h3 {
    font-size: 2rem;
  }

  .product-item {
    flex: 0 0 calc(40% - 2rem);
  }

  .product-item img {
    height: auto;
  }
}

@media (max-width: 768px) {
  .products {
    padding: 2rem 3%;
  }

  .section-title {
    font-size: 1.8rem;
    margin-bottom: 0.5rem;
  }

  .subtitle {
    font-size: 1rem;
    margin-bottom: 2rem;
  }

  .product-main {
    flex-direction: column;
    gap: 2rem;
    padding: 0 1rem;
    margin-bottom: 3rem;
  }

  .product-image {
    max-width: 100%;
  }

  .product-content {
    max-width: 100%;
  }

  .product-content h3 {
    font-size: 1.6rem;
    margin-bottom: 1.5rem;
    text-align: center;
  }

  .feature-text strong {
    font-size: 1.1rem;
  }

  .feature-text p {
    font-size: 0.95rem;
  }

  .feature-list li {
    margin-bottom: 1.2rem;
  }

  .product-item {
    flex: 0 0 calc(90% - 1rem);
    padding: 1.2rem;
    margin: 0 auto;
  }

  .product-grid {
    display: flex;
    flex-wrap: nowrap;
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
    scroll-snap-type: x mandatory;
    padding: 1rem 0.5rem;
  }

  .product-item {
    scroll-snap-align: center;
  }

  .product-item img {
    height: auto;
  }

  .product-item h3 {
    font-size: 1.3rem;
    text-align: center;
    margin: 1rem 0;
  }

  .product-features {
    text-align: left;
  }

  .product-features li {
    font-size: 0.95rem;
    margin-bottom: 0.8rem;
    line-height: 1.4;
  }

  .learn-more {
    display: block;
    margin: 1.2rem auto 0;
    width: 100%;
    max-width: 280px;
    padding: 0.8rem 1.5rem;
  }
}

@media (max-width: 480px) {
  .products {
    padding: 1.5rem 2%;
  }

  .section-title {
    font-size: 1.6rem;
  }

  .subtitle {
    font-size: 0.9rem;
    margin-bottom: 1.5rem;
  }

  .product-main {
    gap: 2rem;
    margin-bottom: 3rem;
  }

  .product-content h3 {
    font-size: 1.4rem;
  }

  .feature-text strong {
    font-size: 1rem;
  }

  .feature-text p {
    font-size: 0.9rem;
  }

  .product-item {
    flex: 0 0 calc(90% - 2rem);
    padding: 1rem;
  }

  .product-item img {
    height: auto;
    margin-bottom: 1.5rem;
  }

  .product-item h3 {
    font-size: 1.2rem;
    margin-bottom: 1rem;
  }

  .product-features li {
    font-size: 0.9rem;
    margin-bottom: 0.6rem;
  }

  .learn-more {
    padding: 0.7rem 1.5rem;
    font-size: 0.9rem;
  }
}
</style>